import React, { useState, useEffect } from 'react'
import {
  Paper,
  Typography,
  CircularProgress,
  Divider,
  Button,
  IconButton,
  Grid,
  Avatar,
} from '@material-ui/core'
import ShareIcon from '@material-ui/icons/Share'
import DeleteIcon from '@material-ui/icons/Delete'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

import { deletePost } from '../../actions/posts'
import ShareDialog from '../ShareDialog/ShareDialog'
import EnterDialog from '../EnterDialog/EnterDialog'
import { getPost } from '../../actions/posts'
import useStyles from './styles'

const RoomDetails = () => {
  const { post, isLoading } = useSelector((state) => state.posts)
  const [enter, setEnter] = useState(false)
  const [openShare, setOpenShare] = useState(false)
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const { id } = useParams()
  const userNow = JSON.parse(localStorage.getItem('profile'))
  const { user } = useSelector((state) => state.user)

  const handleClickEnter = () => {
    setEnter(true)
  }

  const handleCloseEnter = () => {
    setEnter(false)
  }
  const handleClickShare = () => {
    setOpenShare(true)
  }

  const handleCloseShare = () => {
    setOpenShare(false)
  }

  const handleDeletePost = () => {
    dispatch(deletePost(post._id))

    history.push('/')
  }

  const userPage = () => {
    history.push(`/user/${post.username}`)
  }

  useEffect(() => {
    dispatch(getPost(id))
  }, [dispatch, id])

  if (!post) return null

  if (isLoading) {
    return (
      <Paper elevation={6} className={classes.loadingPaper}>
        <CircularProgress size='7em' />
      </Paper>
    )
  }

  return (
    <Paper elevation={6} className={classes.paper}>
      <div className={classes.card}>
        <div className={classes.section}>
          <Typography variant='h3' component='h2'>
            {post.title}
          </Typography>
          <Grid container alignItems='stretch' className={classes.createdBy}>
            <Avatar
              onClick={userPage}
              alt={post.username}
              className={classes.avatar}
              src={user?._id === post.creator ? user?.avatar : post.avatar}
            >
              {post.username.charAt(0)}
            </Avatar>

            <Typography
              onClick={userPage}
              variant='h6'
              style={{ marginLeft: '15px' }}
              className={classes.userName}
            >
              {post.username}
            </Typography>
          </Grid>

          <Grid className={classes.categorynStatus}>
            <Typography
              gutterBottom
              variant='h6'
              color='textSecondary'
              component='h2'
              className={classes.category}
            >
              {post.category}
            </Typography>
            {moment().format('LLLL') < moment(post.roomStart).format('LLLL') ? (
              <Typography variant='body2' className={classes.progressTime}>
                Start {moment(post.roomStart).fromNow()}
              </Typography>
            ) : (
              moment().format('LLLL') >=
                moment(post.roomStart).format('LLLL') && (
                <Typography variant='body2' className={classes.progressTime}>
                  End {moment(post.roomEnd).fromNow()}
                </Typography>
              )
            )}
          </Grid>
          <Typography gutterBottom variant='body1' component='p'>
            {post.message}
          </Typography>

          <Divider style={{ margin: '20px 0' }} />
          <Grid className={classes.roomTime}>
            <Typography variant='h6' className={classes.timeTitle}>
              Start:
              <Typography className={classes.dateRoom}>
                {moment(post.roomStart).format('ll')}
              </Typography>
              <Typography className={classes.timeRoom}>
                {moment(post.roomStart).format('LT')}
              </Typography>
            </Typography>
            <Divider
              orientation='vertical'
              flexItem
              style={{ margin: '5px 0' }}
            />
            <Typography variant='h6' className={classes.timeTitleEnd}>
              End:
              <Typography className={classes.dateRoom}>
                {moment(post.roomEnd).format('ll')}
              </Typography>
              <Typography className={classes.timeRoom}>
                {moment(post.roomEnd).format('LT')}
              </Typography>
            </Typography>
          </Grid>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant='body2'>
            Live Video Chat Coming Soon, please support Us to make it happen.
            🐱‍🏍
          </Typography>
        </div>
        <div className={classes.imageSection}>
          <img
            className={classes.media}
            src={
              post.selectedFile ||
              'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'
            }
            alt={post.title}
          />
          <Button
            variant='contained'
            className={classes.button}
            onClick={handleClickEnter}
          >
            🚪 Enter
          </Button>
          <EnterDialog
            post={post}
            enter={enter}
            roomCategory={post.category}
            handleCloseEnter={handleCloseEnter}
          />
          <IconButton
            aria-label='share'
            component='span'
            className={classes.buttonShare}
            onClick={handleClickShare}
          >
            <ShareIcon post={post} fontSize='small' />
          </IconButton>
          <ShareDialog
            post={post}
            openShare={openShare}
            handleCloseShare={handleCloseShare}
          />
          {(userNow?.result?.googleId === post?.creator ||
            userNow?.result?._id === post.creator) && (
            <IconButton
              aria-label='delete'
              component='span'
              className={classes.buttonDelete}
              onClick={handleDeletePost}
            >
              <DeleteIcon fontSize='small' />
            </IconButton>
          )}
        </div>
      </div>
    </Paper>
  )
}

export default RoomDetails
